import bookmarks from './bookmarks';
import activity from './activity';
import localWidget from './local-widget';
import articleRuntime from './article-runtime';

export default function mountPage(root, options = {}) {
    const controller = new AbortController();
    const {signal} = controller;
    const bookmark = bookmarks(root, signal, options.state?.bookmarks);
    const work = activity(root, signal, options.state?.activity);
    localWidget(root, signal);
    if (options.runtimeReady) {
        options.runtimeReady.then(() => { if (!signal.aborted) articleRuntime(root, signal, options); });
    } else articleRuntime(root, signal, options);
    return {
        snapshot: () => ({bookmarks: bookmark?.snapshot(), activity: work.snapshot()}),
        destroy() {
            root.dispatchEvent(new CustomEvent('tiwb:page-leave', {bubbles: true}));
            // Ghost card pause controls cancel their RAF loops as well as playback.
            root.querySelectorAll('.kg-audio-pause-icon, .kg-video-pause-icon').forEach(control => control.click());
            root.querySelectorAll('audio, video').forEach(media => media.pause());
            controller.abort();
        }
    };
}
